module.exports = __webpack_public_path__ + "img/email-computer.ab0dd021.svg";